import { notStarted } from 'ocfe/src/utils/loadable';
import React from 'react';
import { useTinyMCEConfig } from './api';

export type TinyMCEConfig = {
    allowUserGenHashtags: boolean;
    atMentionsEnabled: boolean;
    // embedlyKey: string;
    excludedHashtags: string;
    fileStackFromSources: string;
    fileStackKey: string;
    generateUrlPreviews: boolean;
    hashMentionJs: string;
    hashtagJs: string;
    insertEmbeddedVideoText: string;
    insertMediaObjectText: string;
    jqueryCdnAddress: string;
    mentionJs: string;
    mostUsedMentions: string[];
    tinyMceEditorStylesUrl: string;
    tinyMceFolderLocation: string;
    tinyMceJs: string;
    tinyMceUrl: string;
};

type TinyMCEConfigLoadableValue = ReturnType<typeof useTinyMCEConfig>;

const TinyMCEContext = React.createContext<TinyMCEConfigLoadableValue>([notStarted(), () => {}, '']);
TinyMCEContext.displayName = 'TinyMCEContext';
export { TinyMCEContext };
